import { render, staticRenderFns } from "./search-result-type-generic.vue?vue&type=template&id=35941c40&scoped=true&"
import script from "./search-result-type-generic.vue?vue&type=script&lang=js&"
export * from "./search-result-type-generic.vue?vue&type=script&lang=js&"
import style0 from "./search-result-type-generic.vue?vue&type=style&index=0&id=35941c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35941c40",
  null
  
)

export default component.exports